import { z } from 'zod';

/**
 * Therapist Agreement digital signature payload (POST /api/v1/therapist/sign-agreement).
 * Client sends a base64-encoded PNG of the drawn signature; we store it encrypted.
 */
export const SignAgreementSchema = z.object({
  agreementVersion: z.string().default('t-v1.0'),
  signatureBase64: z
    .string()
    .min(100, 'Signature image is suspiciously small')
    .max(500_000, 'Signature image exceeds 500 KB')
    .regex(/^data:image\/png;base64,/, 'Signature must be a PNG data URL'),
});
export type SignAgreementInput = z.infer<typeof SignAgreementSchema>;

/** Client ToS acceptance (POST /api/v1/client/accept-tos). */
export const AcceptTosSchema = z.object({
  tosVersion: z.string().default('c-v1.0'),
  deviceId: z.string().min(1).max(120),
});
export type AcceptTosInput = z.infer<typeof AcceptTosSchema>;

/** Read model returned by GET endpoints so the UI can render "signed on ...". */
export const AgreementRecordSchema = z.object({
  agreementVersion: z.string(),
  signedAt: z.string().datetime(),
});
export type AgreementRecord = z.infer<typeof AgreementRecordSchema>;
